import { createApp } from 'vue';
import "default-passive-events"
import '/common/iconfont.css'
import 'element-plus/dist/index.css'
import 'nprogress/nprogress.css'
import App from './App.vue'
import router from "./router"
import store from "./store"
import "./router/router-config"  // 路由守卫，做动态路由的地方
import {post,get,patch,put} from '../common/http.js';
import webtitle from 'vue-wechat-title';
// import {AMap,initAMapApiLoader} from '@vuemap/vue-amap';
// import '@vuemap/vue-amap/dist/style.css'
// initAMapApiLoader({
//     key: '9a83d9c61f967187ffe307f2dfb170fe',
// 	plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
// 	v: '1.4.4'
// })
// //这里的安全密钥不写会导致 行政区查询等API无法使用
// window._AMapSecurityConfig = {
//   securityJsCode: '582ef81a65a94002cb1eeae8c861e285',
// };
const app = createApp(App);
// 全局注册el-icon,start
import * as ElementPlusIcons from '@element-plus/icons-vue';
for (const [key, component] of Object.entries(ElementPlusIcons)) {
   app.component(key, component)
}
// 全局注册el-icon,end
//自定义图标start
import registerSvgIcon from "@/icons/index";
registerSvgIcon(app);
//自定义图标end

//定义全局变量
app.config.globalProperties.$post=post;
app.config.globalProperties.$get=get;
app.config.globalProperties.$patch=patch;
app.config.globalProperties.$put=put;
app.use(webtitle).use(router).use(store).mount('#app');
